import ForbiddenException from '../../lib/ForbiddenException';
import User from '../containers/User';

async function retrieveMyInquiry() {
  const path = '/api/users/my_inquiry';
  const resp = await fetch(path);
  const json = await resp.json();

  return json;
}

export default retrieveMyInquiry;
